import { useEffect, useState } from "react";
import { View, Dimensions } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import Input from "@/ui/Input";
import { ms } from "@/ui/moderateScale";
import ModalContainer from "@/ui/ModalContainer";

const AlertPrompt = () => {
  const prompt = useUISlice((state) => state.alertPrompt);
  const setPrompt = useUISlice((state) => state.setAlertPrompt);
  const [text, setText] = useState("");
  const width = Dimensions.get("window").width;

  useEffect(() => {
    if (!prompt) return;

    setText(prompt.defaultValue || "");
  }, [prompt]);

  if (!prompt) return null;

  const _onPress = () => {
    prompt.button.onPress(text);
  };

  return (
    <ModalContainer
      title={prompt.title}
      subtitle={prompt.subtitle}
      onDismiss={() => setPrompt(undefined)}
      primaryButtonText={prompt.button.text}
      onPrimaryButtonPress={_onPress}
      hideDismissIcon={prompt.hideDismissIcon}
      hideCancel={prompt.hideCancel}
      shouldPersistBackdropClick={prompt.shouldPersistBackdropClick}
      loading={prompt.loading}
      autoFocus
      destructive={prompt.button.destructive}
      modalWidth={Math.min(width - ms(32), 600)}
    >
      <View style={{ height: 16 }} />
      <Input
        autoFocus
        disabled={prompt.loading}
        height={prompt.multiLine ? ms(220) : undefined}
        multiLine={prompt.multiLine}
        value={text}
        placeholder={prompt.placeholder}
        onTextChange={(text) => setText(text)}
      />
    </ModalContainer>
  );
};

export default AlertPrompt;
